import { Component } from 'react';
import is from 'is_js';
import { log } from 'omni-common-ui';
// import { withRouter } from 'react-router';
import PropTypes from 'prop-types';

const ONBEFOREUNLOAD_MSG =
    'Changes you made will not be saved unless you click "Save".';

export class UnsavedChangesTrackingPageComponent extends Component {
  constructor(props) {
    super(props);
    this.state = is.object(this.state) ? this.state : {};
    Object.assign(this.state, {
      // these are set in this._forcePushRoute() and observed in routerWillLeave()
      allowRouteLeave: false,
      isRouterLeaveConfirmed: false,
      routerLeaveNextLocation: null,
    });
  }

  componentWillMount() {
    this._bindRouterWillLeaveHook();
  }

  componentDidUpdate(prevProps) {
    if (prevProps.location &&
      (prevProps.location.pathname ===
        this.props.location.pathname)) return;
    // we're in a different route but the same component is mounted; bind the hook again
    this._bindRouterWillLeaveHook();
  }

  _bindRouterWillLeaveHook() {
    if (! this.props.router || ! this.props.route) {
      log.error('`router` or `route` props not available in UnsavedChangesTrackingPageComponent!');
      return;
    }
    this.props.router.setRouteLeaveHook(
      this.props.route, this.routerWillLeave.bind(this));
  }

  // override this if needed
  _isChangesPresent() {
    return this.props.marking;
  }

  _isNavigationWithChangesRequested() {
    return !! this.state.routerLeaveNextLocation;
  }

  _clearRequestedLocation() {
    this.setState({ routerLeaveNextLocation: null });
  }

  _forcePushRoute(route, otherState = {}, stateNavMutexKey = 'allowRouteLeave') {
    this.setState(Object.assign({}, otherState, {
      [stateNavMutexKey]: true,
    }), () => {
      this.props.pushRoute(route);
      this.setState({
        [stateNavMutexKey]: false,
      });
    });
  }

  _forcePushRequestedLocation() {
    const { routerLeaveNextLocation } = this.state;
    this._forcePushRoute(routerLeaveNextLocation, {
      routerLeaveNextLocation: null,
    }, 'isRouterLeaveConfirmed');
  }

  routerWillLeave(nextLocation) {
    if (! this.state.isRouterLeaveConfirmed &&
        ! this.state.allowRouteLeave &&
          this._isChangesPresent()) {
      this.setState({ routerLeaveNextLocation: nextLocation });
      if (! nextLocation) {
        // During the beforeunload event routerWillLeave does not receive a location object
        // because it isn't possible for it to know the location we're transitioning to.
        return ONBEFOREUNLOAD_MSG;
      }
      return false;
    }
  }
}

UnsavedChangesTrackingPageComponent.propTypes = Object.freeze({
  route: PropTypes.any.isRequired,
  router: PropTypes.any.isRequired,
  pushRoute: PropTypes.func.isRequired,
  marking: PropTypes.bool,
});

// export default withRouter(UnsavedChangesTrackingPageComponent);  // does not seem to work
export default UnsavedChangesTrackingPageComponent;



// WEBPACK FOOTER //
// ./components/UnsavedChangesTrackingPageComponent/index.jsx